import { render, staticRenderFns } from "./WZRankedOverlay.vue?vue&type=template&id=d68184e8&"
import script from "./WZRankedOverlay.vue?vue&type=script&lang=js&"
export * from "./WZRankedOverlay.vue?vue&type=script&lang=js&"
import style0 from "./WZRankedOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports